module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-footer is-hidden"
  }, [_c('div', {
    staticClass: "home-footer__container"
  }, [(_vm.plant) ? _c('artwork', {
    ref: "artwork",
    attrs: {
      "prefix": ((_vm.plant.id) + "_" + (_vm.plant.title)),
      "oeuvre": _vm.plant.content.oeuvre
    }
  }) : _vm._e(), _vm._v(" "), _c('ui-footer')], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-50bd0b9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/footer-home.vue
 ** module id = 751
 ** module chunks = 2
 **/